/* TypeScript file generated from TextStyle.resi by genType. */

/* eslint-disable */
/* tslint:disable */

import * as TextStyleJS from './TextStyle.res.js';

import type {direction as StyleX_direction} from '../../../src/externals/StyleX.gen';

import type {t as FontSizes_t} from '../../../src/resources/theme/FontSizes.gen';

import type {t as Spaces_t} from '../../../src/resources/theme/Spaces.gen';

export type variation = 
    "neutral"
  | "success"
  | "normal"
  | "negative"
  | "important"
  | "warning"
  | "subdued"
  | "primary"
  | "secondary"
  | "placeholder"
  | { NAME: "custom"; VAL: string };

export type props<children,align,variation,weight,size,lineHeight,underlined,strikethrough,italic,wrap,maxLines,direction,opacity> = {
  readonly children: children; 
  readonly align?: align; 
  readonly variation?: variation; 
  readonly weight?: weight; 
  readonly size?: size; 
  readonly lineHeight?: lineHeight; 
  readonly underlined?: underlined; 
  readonly strikethrough?: strikethrough; 
  readonly italic?: italic; 
  readonly wrap?: wrap; 
  readonly maxLines?: maxLines; 
  readonly direction?: direction; 
  readonly opacity?: opacity
};

export const make: React.ComponentType<{
  readonly children: React.ReactNode; 
  readonly align?: 
    "center"
  | "start"
  | "end"; 
  readonly variation?: variation; 
  readonly weight?: 
    "strong"
  | "semibold"
  | "medium"
  | "regular"; 
  readonly size?: FontSizes_t; 
  readonly lineHeight?: Spaces_t; 
  readonly underlined?: boolean; 
  readonly strikethrough?: boolean; 
  readonly italic?: boolean; 
  readonly wrap?: boolean; 
  readonly maxLines?: number; 
  readonly direction?: StyleX_direction; 
  readonly opacity?: number
}> = TextStyleJS.make as any;
